import { SvgIconProps } from './icon-props';

const CheckmarkIcon = ({ className, height = 24, width = 25 }: SvgIconProps) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			viewBox="0 0 25 24"
			fill="none"
			className={className}
		>
			<path
				d="M12.5 0.75C6.29 0.75 1.25 5.79 1.25 12C1.25 18.21 6.29 23.25 12.5 23.25C18.71 23.25 23.75 18.21 23.75 12C23.75 5.79 18.71 0.75 12.5 0.75ZM18.8225 7.845L11.3375 17.1C11.2025 17.265 11.0075 17.3625 10.7975 17.3775C10.7825 17.3775 10.7675 17.3775 10.76 17.3775C10.565 17.3775 10.37 17.3025 10.2275 17.16L6.23 13.1625C5.9375 12.87 5.9375 12.3975 6.23 12.105C6.5225 11.8125 6.995 11.8125 7.2875 12.105L10.6925 15.51L17.66 6.9075C17.9225 6.585 18.395 6.5325 18.7175 6.795C19.04 7.0575 19.0925 7.53 18.83 7.8525L18.8225 7.845Z"
				fill="#218242"
			/>
		</svg>
	);
};

export default CheckmarkIcon;
